import React from 'react';
import './style.css';

import { Header, TabComponent, InspectionButtonModalComponent } from '../../Components';

const VehicleCombinedStatusScreen = ({
  handleStatus,
  vehiclesByStatus,
  companies,
  isLoading,
  loadingDiscard,
  handleCancel,
  handleOk,
  checkModal,
  showModal,
  isModalVisible,
  modalChecked,
  handleToast,
  setLoading,
  certificateLoading,
  cancleReInspection,
  setCertificateLoading,
  loadingSelect,
  setReInspectionId,
  reInspectionModal,
  setReInspectionModal,
  handleCreateInspection,
  handleCreateReInspection,
  handleLicensePlateNumber,
  reInspectionChecked,
  handleReInspectionCheck,
  setReInspectionLisencePlateNumber,
  handleDiscardInspection,
  reInspectionLisencePlateNumber,
  licensePlateNumber,
  handlEmptyFields,
  inputEmpty,
  setInputEmpty,
  checkEmpty,
  setCheckEmpty,
  checkUnselect,
  setCheckUnselect,
  alreadyExist,
}) => {
  return (
    <div className="main-container">
      <div className="container">
        <div className="content-main-container">
          <div style={{ position: 'relative' }}>
            <Header title={true} />

            <TabComponent
              handleCancel={handleCancel}
              handleOk={handleOk}
              checkModal={checkModal}
              showModal={showModal}
              isLoading={isLoading}
              setLoading={setLoading}
              loadingDiscard={loadingDiscard}
              handleDiscardInspection={handleDiscardInspection}
              certificateLoading={certificateLoading}
              setCertificateLoading={setCertificateLoading}
              setReInspectionId={setReInspectionId}
              reInspectionModal={reInspectionModal}
              cancleReInspection={cancleReInspection}
              setReInspectionModal={setReInspectionModal}
              setReInspectionLisencePlateNumber={setReInspectionLisencePlateNumber}
              vehiclesByStatus={vehiclesByStatus}
              handleStatus={handleStatus}
            />
          </div>
          <div className="modals-main-container">
            <InspectionButtonModalComponent
              isModalVisible={isModalVisible}
              reInspectionChecked={reInspectionChecked}
              modalChecked={modalChecked}
              handleCancel={handleCancel}
              loadingSelect={loadingSelect}
              handleOk={handleOk}
              checkModal={checkModal}
              showModal={showModal}
              companies={companies}
              handleToast={handleToast}
              handlEmptyFields={handlEmptyFields}
              inputEmpty={inputEmpty}
              setInputEmpty={setInputEmpty}
              checkEmpty={checkEmpty}
              setCheckEmpty={setCheckEmpty}
              checkUnselect={checkUnselect}
              setCheckUnselect={setCheckUnselect}
              cancleReInspection={cancleReInspection}
              handleReInspectionCheck={handleReInspectionCheck}
              reInspectionModal={reInspectionModal}
              licensePlateNumber={licensePlateNumber}
              reInspectionLisencePlateNumber={reInspectionLisencePlateNumber}
              handleCreateReInspection={handleCreateReInspection}
              handleLicensePlateNumber={handleLicensePlateNumber}
              handleCreateInspection={handleCreateInspection}
              alreadyExist={alreadyExist}
            />
          </div>
          <div className="tabs-bottom-color" />
        </div>
      </div>
    </div>
  );
};
export default VehicleCombinedStatusScreen;
